import { View, ScrollView, Text, Platform, Dimensions } from 'react-native';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { LimitResultCard } from './components/LimitResultCard/LimitResultCard';
import HorizontalScrollScreen from './components/HorizontalScrollScreen/HorizontalScrollScreen';
import WhyVoltSection from './components/WhyVolt';
import SectionHeading from './components/SectionHeading';
import DashboardHeader from './components/Header/Header';
import FaqContainer from './components/FaqContainer/FaqContainer';
import ROUTE from '../../navigationApp/routes';
import InterestCalculatorCard from './components/InterestCalculatorCard/InterestCalculatorCard';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import gs from '../../styles/globalStyles';
import CheckEligibleCard from './components/CheckEligibleCard/CheckEligibleCard';
import { endpoints } from '../../api/apis';
import { addSuffix } from '../../utils/utils';
import FadeInAnimation from '../../sharedComponents/FadinAnimation/FadinAnimation';
import classes from '../../styles/globalClasses';
import ConfirmEditLimit from './components/CheckEligibleCard/ConfirmEditLimit';
import BottomSheetContainer from '../../sharedComponents/Bottomsheet/Bottomsheet';
import { showErrorSheet } from '../../store/slices/errorSlice';
import ScreenWrapper from '@hoc/ScreenWrapper';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import InstaStory from 'react-native-insta-story';
import ls from './Dashboard.styles';
import { StoryData } from './Data';
import { isMobile, getScreenType } from '../../utils';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import { ThemedView } from '@app/theme';
type  DashboardScreenProps = NativeStackScreenProps<PrivateStackParamList , 'HOME'>
 
const DashboardScreen  = ({
  navigation,
  route,
}: DashboardScreenProps) => {
  const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
  const [loading, setLoading] = useState<boolean>(true);
  const [pledgeDetails, setPledgeDetails] = useState<any>({});
  const [showEditLimit, setShowEditLimit] = useState<boolean>(false);
  const [isEditLimitBottomSheetVisible, setIsEditLimitBottomSheetVisible] =
    useState<boolean>(false);
  const [showInterestCalculator, setShowInterestCalculator] =
    useState<boolean>(false);
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const {showMyAccountIcon} = useAppSelector(state=>state.platformParams)
  const { t } = useTranslation('translation', {
    keyPrefix: route?.name as String,
  });
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const {isPLJ,isfromTDL} = useAppSelector((state)=>state.platformParams)

  const openEditLimitBottomSheet = () => {
    setIsEditLimitBottomSheetVisible(true);
  };
  const closeBottomSheet = () => {
    setIsEditLimitBottomSheetVisible(false);
  };
  const ctaAction = () => {
    setButtonLoader(true);
    let Route = auth?.userDetails?.linkedApplications[0]?.currentStepId;
    if (
      auth?.userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null
    ) {
      Route = ROUTE.VERIFY_EMAIL;
    }
    setTimeout(() => {
      if(Route) {
        navigation.navigate(Route);
      }
      setButtonLoader(false);
    }, 200);
  };


  const fetchShowEditLimit = () => {
    const accountId = auth?.userDetails?.linkedApplications[0]?.accountId;
    const url = endpoints.showEnableLimit + accountId;
    axios
      .get(url)
      .then(res => {
        setShowEditLimit(res?.data?.isEnabled);
      })
      .catch(err => {
        console.log('showEditLimit error', err , url);
      });
  };

  const fetchPlatformConfig = () => {
    const url = endpoints.platformDetailsApi;
    axios
      .get(url)
      .then(res => {
        setShowInterestCalculator(
          res?.data?.platformSDKConfig?.showInterestCalculator,
        );
      })
      .catch(err => {
        console.log('platform config error', err);
      });
  };

  const fetchPledgeLimit = () => {
    const applicationId =
      auth?.userDetails?.linkedApplications[0]?.applicationId;
    const url = endpoints.pledgeData + applicationId;
    axios
      .get(url)
      .then(res => {
        const pledgeLimitResponse = res.data;
        const stepResponseObject = pledgeLimitResponse?.stepResponseObject;
        const repositoryAssetMetadataMap =
          pledgeLimitResponse?.stepResponseObject?.repositoryAssetMetadataMap;
        const creditLimit =
          (stepResponseObject?.approvedCreditLimit || 0) +
          (stepResponseObject?.requestCreditLimit || 0);
        const camsDate = repositoryAssetMetadataMap?.CAMS.casFetchDate;
        const karvyDate = repositoryAssetMetadataMap?.KARVY.casFetchDate;
        const latestDate = Math.max(camsDate, karvyDate);

        const karvyDateToShow = moment.unix(latestDate).format('DD-MM-yyyy');
        const displayDate = karvyDateToShow.substring(0, 2);
        const dateName = `${displayDate}${addSuffix(displayDate)}`;
        const monthName = moment.unix(Number(latestDate)).format('MMM');
        const yearName = karvyDateToShow.slice(-4);
        let lastEditDate = `${dateName} ${monthName} ${yearName}`;
        let creditLimitAmount = 0;
        if (stepResponseObject) {
          if (creditLimit != null && creditLimit > 0) {
            creditLimitAmount = creditLimit;
          } else {
            creditLimitAmount = 0;
          }
        }
        console.log('pledge limit', creditLimitAmount, lastEditDate);
        setPledgeDetails({ creditLimitAmount, lastEditDate });
        dispatch(updatePartnerParams({showCall:creditLimitAmount>0}))
      })
      .catch(err => {
        console.log('pledgle limit error', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOnPress = () => {
    navigation.navigate(ROUTE.INTEREST_CALCULATOR);
  };

  const continueEditLimitAction = () => {
    let applicationId = auth?.userDetails?.linkedApplications[0]?.applicationId;
    const url = endpoints.editLimitRoute + applicationId;
    axios
      .get(url)
      .then(res => {
        const currentStepId = res.data.updatedApplicationObj.currentStepId;
        navigation.navigate(currentStepId);
      })
      .catch(err => {
        dispatch(
          showErrorSheet({
            isErrorSheetVisible : true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
          }),
        );
      });
  };

  useEffect(() => {
    if(auth.isAuthenticated && auth.userDetails!==null){
      fetchPledgeLimit();
      fetchShowEditLimit();
      fetchPlatformConfig();
  }
}, [auth]);



  const { creditLimitAmount, lastEditDate } = pledgeDetails;
  return (
    <>
     <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
        <DashboardHeader
          callDataVisible ={creditLimitAmount > 0}
          showMyAccountIcon={showMyAccountIcon}
          navigation={navigation}
          name={auth?.userDetails?.user?.fullName?.split(' ')[0] ?? ''}
        />
        <ScrollView>

          <ThemedView flex={1}  backgroundColor="bg-surface-page">
            {
              Dimensions.get('window').width < 765 &&
              <InstaStory
                data={StoryData}
                duration={10}
                style={Platform.OS !== 'web' ? ls.instaStoryContainer : {
                  marginTop: 24,

                }}
                avatarWrapperStyle = {Platform.OS !== 'web' ? ls.wrapper : {
                  ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? {width: 508/5} : {width: Dimensions.get('window').width/4.5},
                }}
                avatarTextStyle = {Platform.OS !== 'web' ? ls.wrapper : {
                  ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? {width: 508/7} : {width: Dimensions.get('window').width/6.5},
                  marginLeft:12,
                  alignItems:'center',
                  color:'#667085'
                }}
                unPressedBorderColor='transparent'
                pressedBorderColor='transparent'
                pressedAvatarTextColor='#667085'
                unPressedAvatarTextColor='#667085'
                storyImageStyle = {ls.storyImageStyle}
              />
            }
            {loading ? (
              <ShimmerPlaceholder
                // stopAutoRun
                style={{
                  width: '50%',
                  height: 24,
                  marginTop: 24,
                  borderRadius: 8,
                  marginHorizontal: 16,
                }}
              />
            ) : (
              creditLimitAmount > 0 && (
                <FadeInAnimation delay={100} duration={1000}>
                  <Text
                    style={[
                      classes.h4s,
                      gs.setColor('#1d2939'),
                      gs.setMarginHorizontal(16),
                      gs.setMarginTop(24),
                    ]}>
                    Your instant cash is ready
                  </Text>
                </FadeInAnimation>
              )
            )}
            {loading && (
              <ThemedView
                style={{
                  padding: 16,
                  borderRadius: 8,
                  backgroundColor: '#ddd',
                  marginTop: 24,
                  marginHorizontal: 16,
                }}>
                <ShimmerPlaceholder
                  style={[
                    gs.setWidth('100%'),
                    gs.setHeight(180),
                    {
                      borderRadius: 8,
                    },
                  ]}
                />
              </ThemedView>
            )}
            {!loading && creditLimitAmount > 0 ? (
              <LimitResultCard
                amount={creditLimitAmount}
                showEditLimit={showEditLimit}
                lastEditDate={lastEditDate}
                ctaAction={ctaAction}
                editLimitAction={openEditLimitBottomSheet}
                buttonLoader={buttonLoader}
                urlParams={{isPLJ,isfromTDL}}
              />
            ) : (
              !loading && (
                <CheckEligibleCard
                  ctaAction={ctaAction}
                  t={t}
                  buttonLoader={buttonLoader}
                />
              )
            )}
            <SectionHeading heading={'Why Volt Money you ask?'} />
            <WhyVoltSection />
            {showInterestCalculator && (
              <InterestCalculatorCard handleOnPress={handleOnPress} />
            )}
            <SectionHeading heading={'Learn about Loan against MF'} />
            <HorizontalScrollScreen />
            <FaqContainer navigation={navigation} />
          </ThemedView>
        </ScrollView>
        <BottomSheetContainer
          isVisible={isEditLimitBottomSheetVisible}
          close={closeBottomSheet}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          containerStyle={gs.setBg('#fefefe')}>
          <ConfirmEditLimit
            onClose={closeBottomSheet}
            ctaAction1={continueEditLimitAction}
            ctaAction2={closeBottomSheet}
          />
        </BottomSheetContainer>
      </ScreenWrapper>
    </>
  );
};

export default DashboardScreen;
